import { Trans } from '@lingui/react/macro';
import Box from '@mui/material/Box';

import { Form, Formik } from 'formik';

import { Analytics } from '@watershed/analytics/analyticsUtils';
import ArrowRightIcon from '@watershed/icons/components/ArrowRight';
import isValidEmail from '@watershed/shared-universal/utils/isValidEmail';
import { TestIds } from '@watershed/shared-universal/utils/testUtils';
import Button from '@watershed/ui-core/components/Button';
import CircularProgress from '@watershed/ui-core/components/CircularProgress';
import TextField from '@watershed/ui-core/components/Form/TextField';

import { EmailLoginState } from '../types';

export function EmailForm({
  state,
  onSubmit,
  onError,
}: {
  state: EmailLoginState;
  onSubmit: (email: string) => Promise<void>;
  onError: (error: string) => void;
}) {
  return (
    <Formik
      initialValues={{ email: state.email || '' }}
      onSubmit={(values) => {
        Analytics.action('emailForm', {
          email: values.email,
        });
        if (!isValidEmail(values.email)) {
          Analytics.error('emailForm', {
            email: values.email,
            error: 'Invalid email',
          });
          onError('Invalid email');
          return;
        }

        void onSubmit(values.email);
      }}
    >
      <Form style={{ display: 'flex', alignItems: 'flex-end' }}>
        <Box paddingRight={1} flexGrow={1}>
          <TextField
            id="email"
            type="email"
            label={<Trans context="Form field label">Email</Trans>}
            visuallyHideLabel
            autoComplete="email"
            enterKeyHint="next"
            autoFocus
          />
        </Box>
        <Button
          isIcon
          type="submit"
          color="primary"
          title={state.fetching ? 'Loading' : 'Submit'}
          aria-busy={state.fetching}
          size="large"
          data-testid={TestIds.SubmitEmailButton}
        >
          {state.fetching ? <CircularProgress size={16} /> : <ArrowRightIcon />}
        </Button>
      </Form>
    </Formik>
  );
}
